<style scoped lang="stylus" rel="stylesheet/stylus"></style>

<template>
	<div class="container">
		<div class="header">
			<slot name="header"></slot>
		</div>
		<main>
			<!--<slot></slot>-->
			<slot name="default"></slot>
		</main>
		<footer>
			<slot name="footer"></slot>
		</footer>
	</div>
</template>

<script>
export default {
	name: 'baseLayout',
	components: {},
	data() {
		return {}
	}
}
</script>
